import { FC, ReactNode } from "react";
import { twMerge } from "tailwind-merge";

export type ContentSidebarHeaderProps = {
  className?: string;
  visibleOnMobile?: boolean;
  panelType?: "sidebar" | "overlay";
  unIndented?: boolean;
  children: ReactNode | ReactNode[];
};

export const ContentSidebarHeader: FC<ContentSidebarHeaderProps> = ({
  className,
  visibleOnMobile,
  children,
  panelType = "sidebar",
  unIndented = false,
}) => (
  <div
    className={twMerge(
      "flex-none",
      panelType === "sidebar" && "min-h-[--sidebar-header-height]",
      panelType === "sidebar" && !unIndented && "pl-2",
      panelType === "overlay" && "flex items-center justify-between gap-2 pb-2",
      !visibleOnMobile && "hidden lg:flex",
      className,
    )}
  >
    {children}
  </div>
);
